import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminListContact } from "../../lib/api";

export default function ConciergePanel() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminListContact()
      .then(setRows)
      .catch(() => toast.error("Could not load messages"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="concierge-panel">
      <header className="mb-8">
        <p className="ed-overline mb-2">Inquiries</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-[var(--ed-ink)]">Concierge Messages</h1>
        <p className="text-[var(--ed-ink-muted)] text-sm mt-1.5">{rows.length} message{rows.length === 1 ? "" : "s"} from the public contact form.</p>
      </header>

      {loading ? (
        <p className="text-[var(--ed-ink-muted)] py-16 text-center">Loading…</p>
      ) : rows.length === 0 ? (
        <div className="border border-dashed border-[var(--ed-rule)] rounded-sm p-16 text-center">
          <p className="text-[var(--ed-ink-muted)]">No concierge messages yet.</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="admin-messages">
          {rows.map((m) => (
            <article key={m.id} className="border border-[var(--ed-rule)] bg-[var(--ed-bg)] rounded-sm p-5">
              <header className="flex items-start justify-between gap-4 mb-3 pb-3 border-b border-[var(--ed-rule)]">
                <div>
                  <h3 className="font-serif text-lg text-[var(--ed-ink)]">{m.subject || "(no subject)"}</h3>
                  <p className="text-[var(--ed-ink-muted)] text-xs mt-1">
                    {m.full_name} · <a href={`mailto:${m.email}`} className="text-[var(--ed-emerald)] hover:underline">{m.email}</a>
                  </p>
                </div>
                <p className="text-[var(--ed-ink-muted)] text-xs whitespace-nowrap">{(m.created_at || "").slice(0, 10)}</p>
              </header>
              <p className="text-[var(--ed-ink-soft)] text-sm leading-relaxed whitespace-pre-wrap">{m.message}</p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
